import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimengModule } from '../shared/primeng.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CarouselModule } from 'primeng/carousel';
import { NgImageSliderModule } from 'ng-image-slider';
import { PanelModule } from 'primeng/panel';
import { RatingModule } from 'primeng/rating';
import { RealEstateComponent } from './real-estate/real-estate.component';
import { IndustriesRouting } from './industries-routing.module';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SoftwareServiceComponent } from './software-service/software-service.component';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { HealthCareServiceComponent } from './health-care-service/health-care-service.component';
import { DesignServicesComponent } from './design-services/design-services.component';
import { DigitalMarketingComponent } from './digital-marketing/digital-marketing.component';
import { WritingAndEditingComponent } from './writing-and-editing/writing-and-editing.component';
import { MediaProductionComponent } from './media-production/media-production.component';
import { MusicAudioVoiceComponent } from './music-audio-voice/music-audio-voice.component';
import { ConsultingAndProfessionalComponent } from './consulting-and-professional/consulting-and-professional.component';
import { LegalAndCompianceServicesComponent } from './legal-and-compiance-services/legal-and-compiance-services.component';
import { LogisticsSupplyChainComponent } from './logistics-supply-chain/logistics-supply-chain.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { EnvironmentalServicesComponent } from './environmental-services/environmental-services.component';
import { ReasearchAndAnalysisComponent } from './reasearch-and-analysis/reasearch-and-analysis.component';
import { EventServicesComponent } from './event-services/event-services.component';
import { TrainingAndEducationalServicesComponent } from './training-and-educational-services/training-and-educational-services.component';



@NgModule({
  declarations: [
    RealEstateComponent,
    SoftwareServiceComponent,
    HealthCareServiceComponent,
    DesignServicesComponent,
    DigitalMarketingComponent,
    WritingAndEditingComponent,
    MediaProductionComponent,
    MusicAudioVoiceComponent,
    ConsultingAndProfessionalComponent,
    LegalAndCompianceServicesComponent,
    LogisticsSupplyChainComponent,
    InsuranceComponent,
    EnvironmentalServicesComponent,
    ReasearchAndAnalysisComponent,
    EventServicesComponent,
    TrainingAndEducationalServicesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    NgImageSliderModule,
    PrimengModule,
    FormsModule,
    TranslateModule,
    PanelModule,
    CarouselModule,
    RatingModule,
    AvatarModule,
    AvatarGroupModule,
    CommonComponentsModule,
    IndustriesRouting
  ]
})
export class IndustriesModule { }
